import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmProductsRoute: InvariantJiraRoute = {
	name: 'csm-products',
	path: '/jira/customer-service-management/products',
	exact: true,
};
